import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Portfolio({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Portfolio" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="portfolioPanel">
            <Trans i18nKey="portfolioDetails" />

            <h2 className="text-center titles text-orange-500">{t("technologies")}</h2>

            <p className="text-center">ReactJs</p>
        </Dialog>
    )
}